module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "StudentReports"
  }, [_c('h1', {
    staticClass: "m-label m-label-custom"
  }, [_vm._v("対象")]), _vm._v(" "), _c('table-c', [_c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("id")
      }
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_id")
      }
    }
  }, [_vm._v("student_id")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_name")
      }
    }
  }, [_vm._v("生徒")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_kana")
      }
    }
  }, [_vm._v("せいと")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("tutor_id")
      }
    }
  }, [_vm._v("tutor_id")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("tutor_name")
      }
    }
  }, [_vm._v("先生")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("tutor_kana")
      }
    }
  }, [_vm._v("せんせい")])], 1), _vm._v(" "), _vm._l((_vm.orderedStudent_tutors), function(list, index) {
    return _c('tr-c', {
      key: index.id,
      staticClass: "tr_hover",
      class: {
        'list-edit': list.id == _vm.edit_id.edit_id
      },
      attrs: {
        "slot": "tr-td"
      },
      slot: "tr-td"
    }, [_c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(list.id))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(list.student_id))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(_vm.student.f_name) + " " + _vm._s(_vm.student.l_name))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(_vm.student.f_name_kana) + " " + _vm._s(_vm.student.l_name_kana))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(list.tutor_id))]), _vm._v(" "), (list.tutor) ? [_c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(list.tutor.f_name) + " " + _vm._s(list.tutor.l_name))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(list.tutor.f_name_kana) + " " + _vm._s(list.tutor.l_name_kana))])] : [_c('td-c'), _vm._v(" "), _c('td-c')]], 2)
  })], 2), _vm._v(" "), _c('h1', {
    staticClass: "m-label m-label-custom"
  }, [_vm._v("報告書")]), _vm._v(" "), _c('div', {
    staticClass: "index-box",
    on: {
      "scroll": _vm.offset
    }
  }, [_c('table-c', [_c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('th-c', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("削除")]), _vm._v(" "), _c('th-c', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("編集")]), _vm._v(" "), (_vm.id) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("id")
      }
    }
  }, [_vm._v("ID")])] : _vm._e(), _vm._v(" "), (_vm.student_tutor_id) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_tutor_id")
      }
    }
  }, [_vm._v("student_tutor_id")])] : _vm._e(), _vm._v(" "), (_vm.student_name) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_name")
      }
    }
  }, [_vm._v("生徒")])] : _vm._e(), _vm._v(" "), (_vm.student_kana) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_kana")
      }
    }
  }, [_vm._v("せいと")])] : _vm._e(), _vm._v(" "), (_vm.tutor_name) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("tutor_name")
      }
    }
  }, [_vm._v("先生")])] : _vm._e(), _vm._v(" "), (_vm.tutor_kana) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("tutor_kana")
      }
    }
  }, [_vm._v("せんせい")])] : _vm._e(), _vm._v(" "), (_vm.month) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("month")
      }
    }
  }, [_vm._v("何月分")])] : _vm._e(), _vm._v(" "), (_vm.state) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("state")
      }
    }
  }, [_vm._v("現状")])] : _vm._e(), _vm._v(" "), (_vm.note) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("note")
      }
    }
  }, [_vm._v("備考")])] : _vm._e(), _vm._v(" "), (_vm.file_name) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("file_name")
      }
    }
  }, [_vm._v("ファイル名")])] : _vm._e(), _vm._v(" "), (_vm.points_english) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_english")
      }
    }
  }, [_vm._v("英語")])] : _vm._e(), _vm._v(" "), (_vm.points_mathematics) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_mathematics")
      }
    }
  }, [_vm._v("数学")])] : _vm._e(), _vm._v(" "), (_vm.points_japanese) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_japanese")
      }
    }
  }, [_vm._v("国語")])] : _vm._e(), _vm._v(" "), (_vm.points_science) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_science")
      }
    }
  }, [_vm._v("理科")])] : _vm._e(), _vm._v(" "), (_vm.points_socialstudies) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_socialstudies")
      }
    }
  }, [_vm._v("社会")])] : _vm._e(), _vm._v(" "), (_vm.file) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("file")
      }
    }
  }, [_vm._v("ファイル")])] : _vm._e(), _vm._v(" "), (_vm.user) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("user")
      }
    }
  }, [_vm._v("User")])] : _vm._e(), _vm._v(" "), (_vm.created_at) ? [_c('th-c', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    nativeOn: {
      "click": function($event) {
        return _vm.sort("created_at")
      }
    }
  }, [_vm._v("作成日")])] : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.filteredReports), function(list, index) {
    return _c('tr-c', {
      key: index.id,
      staticClass: "tr_hover",
      class: {
        'list-edit': list.id == _vm.edit_id.edit_id
      },
      attrs: {
        "slot": "tr-td"
      },
      slot: "tr-td"
    }, [(list.id == _vm.edit_id.edit_id) ? [_c('td-c', {
      staticClass: "del",
      nativeOn: {
        "click": function($event) {
          return _vm.cancelReport(list)
        }
      }
    }, [_vm._v("戻る")]), _vm._v(" "), _c('td-c', {
      staticClass: "del",
      nativeOn: {
        "click": function($event) {
          return _vm.patchReport(list)
        }
      }
    }, [_vm._v("更新")]), _vm._v(" "), (_vm.id) ? [_c('td-c', [_vm._v(_vm._s(list.id))])] : _vm._e(), _vm._v(" "), (_vm.student_tutor_id) ? [_c('td-c', [_vm._v(_vm._s(list.student_tutor_id))])] : _vm._e(), _vm._v(" "), (_vm.student_name) ? [_c('td-c', [_vm._v(_vm._s(list.student_tutor.student.f_name) + " " + _vm._s(list.student_tutor.student.l_name))])] : _vm._e(), _vm._v(" "), (_vm.student_kana) ? [_c('td-c', [_vm._v(_vm._s(list.student_tutor.student.f_name_kana) + " " + _vm._s(list.student_tutor.student.l_name_kana))])] : _vm._e(), _vm._v(" "), (list.tutor) ? [(_vm.tutor_name) ? [_c('td-c', [_vm._v(_vm._s(list.student_tutor.tutor.f_name) + " " + _vm._s(list.student_tutor.tutor.l_name))])] : _vm._e(), _vm._v(" "), (_vm.tutor_kana) ? [_c('td-c', [_vm._v(_vm._s(list.student_tutor.tutor.f_name_kana) + " " + _vm._s(list.student_tutor.tutor.l_name_kana))])] : _vm._e()] : [_c('td-c'), _vm._v(" "), _c('td-c')], _vm._v(" "), (_vm.month) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.month),
        expression: "list.month"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.month)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "month", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.state) ? [_c('td-c', {
      staticClass: "select"
    }, [_c('multiselect', {
      attrs: {
        "options": _vm.State,
        "label": "name",
        "show-labels": false,
        "placeholder": "現状"
      },
      model: {
        value: (_vm.watchPatch.state),
        callback: function($$v) {
          _vm.$set(_vm.watchPatch, "state", $$v)
        },
        expression: "watchPatch.state"
      }
    })], 1)] : _vm._e(), _vm._v(" "), (_vm.note) ? [_c('td-c', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.note),
        expression: "list.note"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "note", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.file_name) ? [_c('td-c', {
      staticClass: "select"
    }, [_c('multiselect', {
      attrs: {
        "options": _vm.fileName,
        "label": "name",
        "show-labels": false,
        "placeholder": "ファイル名"
      },
      model: {
        value: (_vm.watchPatch.file_name),
        callback: function($$v) {
          _vm.$set(_vm.watchPatch, "file_name", $$v)
        },
        expression: "watchPatch.file_name"
      }
    })], 1)] : _vm._e(), _vm._v(" "), (_vm.points_english) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_english),
        expression: "list.points_english"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_english)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_english", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.points_mathematics) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_mathematics),
        expression: "list.points_mathematics"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_mathematics)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_mathematics", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.points_japanese) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_japanese),
        expression: "list.points_japanese"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_japanese)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_japanese", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.points_science) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_science),
        expression: "list.points_science"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_science)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_science", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.points_socialstudies) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_socialstudies),
        expression: "list.points_socialstudies"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_socialstudies)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_socialstudies", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.file) ? [_c('td-c', [_c('form', {
      staticClass: "update_form",
      attrs: {
        "enctype": "multipart/form-data"
      }
    }, [_c('input', {
      attrs: {
        "type": "file",
        "id": "file"
      },
      on: {
        "change": _vm.patchSelectedFile
      }
    })])])] : _vm._e(), _vm._v(" "), (_vm.user) ? [_c('td-c', [_vm._v(_vm._s(list.user.user))])] : _vm._e(), _vm._v(" "), (_vm.created_at) ? [_c('td-c', [_vm._v(_vm._s(list.created_at.substring(0, 10)))])] : _vm._e()] : _vm._e(), _vm._v(" "), (list.id !== _vm.edit_id.edit_id) ? [_c('td-c', {
      staticClass: "del",
      nativeOn: {
        "click": function($event) {
          return _vm.deleteReport(list)
        }
      }
    }, [_vm._v("削除")]), _vm._v(" "), _c('td-c', {
      staticClass: "del",
      nativeOn: {
        "click": function($event) {
          return _vm.edit(list)
        }
      }
    }, [_vm._v("編集")]), _vm._v(" "), (_vm.id) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.id))])] : _vm._e(), _vm._v(" "), (_vm.student_tutor_id) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.student_tutor_id))])] : _vm._e(), _vm._v(" "), (_vm.student_name) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.student_tutor.student.f_name) + " " + _vm._s(list.student_tutor.student.l_name))])] : _vm._e(), _vm._v(" "), (_vm.student_kana) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.student_tutor.student.f_name_kana) + " " + _vm._s(list.student_tutor.student.l_name_kana))])] : _vm._e(), _vm._v(" "), (list.tutor) ? [(_vm.tutor_name) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.student_tutor.tutor.f_name) + " " + _vm._s(list.student_tutor.tutor.l_name))])] : _vm._e(), _vm._v(" "), (_vm.tutor_kana) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.student_tutor.tutor.f_name_kana) + " " + _vm._s(list.student_tutor.tutor.l_name_kana))])] : _vm._e()] : [_c('td-c'), _vm._v(" "), _c('td-c')], _vm._v(" "), (_vm.month) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.month))])] : _vm._e(), _vm._v(" "), (_vm.state) ? [(list.state === 0) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (list.state === 1) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v("提出済")]) : _vm._e(), _vm._v(" "), (list.state === 2) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v("連絡済")]) : _vm._e(), _vm._v(" "), (list.state === 3) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v("未提出")]) : _vm._e(), _vm._v(" "), (list.state === 4) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v("テキスト未使用")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.note) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.note))])] : _vm._e(), _vm._v(" "), (_vm.file_name) ? [(list.file_name === 0) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (list.file_name === 1) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v("指導報告書")]) : _vm._e(), _vm._v(" "), (list.file_name === 2) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v("引継文章")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.points_english) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_english))])] : _vm._e(), _vm._v(" "), (_vm.points_mathematics) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_mathematics))])] : _vm._e(), _vm._v(" "), (_vm.points_japanese) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_japanese))])] : _vm._e(), _vm._v(" "), (_vm.points_science) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_science))])] : _vm._e(), _vm._v(" "), (_vm.points_socialstudies) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_socialstudies))])] : _vm._e(), _vm._v(" "), (_vm.file) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    })] : _vm._e(), _vm._v(" "), (_vm.user) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.user.user))])] : _vm._e(), _vm._v(" "), (_vm.created_at) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkReport(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.created_at.substring(0, 10)))])] : _vm._e()] : _vm._e()], 2)
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8f50148"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Student/StudentReports.vue
// module id = 1449
// module chunks = 0